import { isDevelopment } from 'env-utils';
import { FC } from 'react';
import ConnectivityBannerContainer from '../../connectors/containers/ConnectivityBannerContainer';
import SnoozeBannerContainer from '../../exclusions/containers/SnoozeBannerContainer';
import MaintenanceBannerContainer from '../../maintenance/containers/MaintenanceBannerContainer';
import { useIsScanning } from '../../new-scan/actions/scan-actions';
import ScannerProgressContainer from '../../new-scan/containers/ScannerProgressContainer';
import WhatsNewContainer from '../../whats-new/containers/WhatsNewContainer';

const PageHeader: FC = () => {
  const isScanning = useIsScanning();

  return (
    <>
      <ConnectivityBannerContainer />
      <MaintenanceBannerContainer />
      <WhatsNewContainer />
      <ScannerProgressContainer />
      {!isScanning && isDevelopment() && <SnoozeBannerContainer />}
    </>
  );
};

export default PageHeader;
